import { Component, Input, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ProductService } from "src/app/services/api/product.service";
import { LangService } from "src/app/services/lang/lang.service";
import { WinService } from "src/app/services/win.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Sizing } from "src/app/lib/sizing";
import { SessionService } from "src/app/services/session.service";
import { CartService } from "src/app/services/api/cart.service";
// import { FbpixelService } from "src/app/services/api/fbpixel.service";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"],
})
export class ProductComponent implements OnInit {
	/**
	 * roduct link from angular routing
	 */
	prouctlink: any = null;

	/**
	 * the actual product from magento database
	 */
	product: any = null;

	imageUrl: any = null;

	/** product theme */
	headerClass: any = "bg-transparent";
	bg = "bg-red";
	nameColor = "fc-red";
	ytBlockId: any = 2; /* 2 is the default yt block id from admin content block */

	// To force login customer to write review
	isAccessible = true;

	is404NotFound = false;

	constructor(
		public winService: WinService,
		public router: Router,
		public _route: ActivatedRoute,
		public productService: ProductService,
		public lang: LangService,
		public sessionService: SessionService,
		public sanitizer: DomSanitizer,
		public cartService: CartService,
	) {}

	ngOnInit() {
		document.title='Durable Sticker';
		this.cartService.getCartId().then(quote_id => {
		});

		this._route.paramMap.subscribe((url_param) => {
			let prouctlink = url_param.get("prouctlink");
			let regex = /^([a-zA-Z0-9_\-\.]+)\.html?$/;
			let match = prouctlink.match(regex);
			if (match) {
				this.productService.setLoader(true);
				this.product = null;
				this.prouctlink = match;

				
				let url = this.productService.getStoreUrl("/V1/products/" + this.prouctlink[1]);

				this.productService.get(url).subscribe(
					(result) => {
						this.product = result;
						this.imageUrl = this.productService.getUrl("/media/catalog/product" + result.media_gallery_entries[0].file);

						this.setColorTheme(this.product.sku);
						this.productService.setLoader(false);
					},
					(error) => this.requestErrorHandler(error)
				);
			} else {
				this.is404NotFound = true;
			}
		});

		// to force login the customer
		this._route.queryParams.subscribe((params) => {
			let forceLogin: boolean = params["forceLogin"];
			if (forceLogin != null) {
				if (this.sessionService.user.isLogedIn) {
					this.isAccessible = false;
				} else {
					this.isAccessible = true;
				}
			} else {
				this.isAccessible = false;
			}
		});
	}


	/**
	 * 
	 */
	setColorTheme(productSku: string = "") {
		if (productSku == "durable-sticker") {
			this.bg = "bg-red";
			this.nameColor = "fc-red";
			this.ytBlockId = 43;
		}
		if (productSku == "durable-sticker-roll") {
			this.bg = "bg-red";
			this.nameColor = "fc-white";
			this.ytBlockId = 43;
		}
		if (productSku == "matte-sticker") {
			this.bg = "bg-blue";
			this.nameColor = "fc-yellow";
			this.ytBlockId = 44;
			
		}
		if (productSku == "outdoor-sticker") {
			this.bg = "bg-blue";
			this.nameColor = "fc-white";
			// this.ytBlockId = 44;
		}
		if (productSku == "glossy-sticker") {
			this.bg = "bg-green";
			this.nameColor = "fc-blue";
			this.ytBlockId = 45;
		}
		if (productSku == "transparent-sticker") {
			this.bg = "bg-green";
			this.nameColor = "fc-blue";
			this.ytBlockId = 62;
		}
		if (productSku == "budget-sticker") {
			this.bg = "bg-blue";
			this.nameColor = "fc-yellow";
			this.ytBlockId = 65;
		}
		if (productSku == "budget-sticker-roll") {
			this.bg = "bg-blue";
			this.nameColor = "fc-yellow";
			this.ytBlockId = 65;
		}
		if (productSku == "custom-cards") {
			this.bg = "bg-green";
			this.nameColor = "fc-blue";
			this.ytBlockId = 71;
		}
	}

	/**
	 * process the error toast if the product doesn't exists
	 */
	requestErrorHandler(error) {
		this.is404NotFound = true;
		this.productService.setLoader(false);
		// this.productService.errorHandler(error);
		// this.router.navigate(["/catalog"]);
	}
}
